import { yemboApiCall } from './_yemboApiCall';

// biome-ignore lint/suspicious/noExplicitAny: legacy API action interface
type ApiAction = Record<string, any>;

const url = 'invite';

export class SendInviteError extends Error {
  isEmailError: boolean;
  isPhoneError: boolean;

  constructor({ message = '', isEmailError = false, isPhoneError = false } = {}) {
    super(message);
    this.isEmailError = isEmailError;
    this.isPhoneError = isPhoneError;
  }
}

export const postInviteApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({
    method: 'POST',
    url,
    ...action,
    onError: (error: ApiAction) => {
      action.onError?.(error);

      const { status, isEmailError, isPhoneError } = error?.response?.data ?? {};

      const errorMessage = status?.[0]?.message;

      // Manually throw a custom error since yemboApiCall doesn't propagate errors by default.
      // This allows error handling at the top level.
      throw new SendInviteError({
        message: errorMessage ?? '',
        isEmailError,
        isPhoneError,
      });
    },
  });

export const postInviteValidatePhoneApi = async (action: ApiAction): Promise<unknown> =>
  await yemboApiCall({
    method: 'POST',
    url: `${url}/validate-phone`,
    ...action,
  });
